// This file is auto-generated by @hey-api/openapi-ts

import type { Options as ClientOptions, TDataShape, Client } from './client'
import { client as _heyApiClient } from './client.gen'
import type {
  ListAdvisorStudentTabletViolationsData,
  ListAdvisorStudentTabletViolationsResponses,
  ListAdvisorStudentTabletViolationsErrors,
  ListAdvisorStudentTabletViolationUrlsData,
  ListAdvisorStudentTabletViolationUrlsResponses,
  ListAdvisorStudentTabletViolationUrlsErrors,
  ListAdvisorStudentTabletViolationOfflinesData,
  ListAdvisorStudentTabletViolationOfflinesResponses,
  ListAdvisorStudentTabletViolationOfflinesErrors,
  ListAdvisorStudentTabletViolationDeviceUsesData,
  ListAdvisorStudentTabletViolationDeviceUsesResponses,
  ListAdvisorStudentTabletViolationDeviceUsesErrors,
  ListAdvisorStudentTabletViolationAppUsesData,
  ListAdvisorStudentTabletViolationAppUsesResponses,
  ListAdvisorStudentTabletViolationAppUsesErrors,
  ListAdvisorStudentTabletUrlVisitsData,
  ListAdvisorStudentTabletUrlVisitsResponses,
  ListAdvisorStudentTabletUrlVisitsErrors,
  ListAdvisorStudentTabletDeviceUsesData,
  ListAdvisorStudentTabletDeviceUsesResponses,
  ListAdvisorStudentTabletDeviceUsesErrors,
  ListAdvisorStudentTabletAppUsesData,
  ListAdvisorStudentTabletAppUsesResponses,
  ListAdvisorStudentTabletAppUsesErrors,
  QueryAdvisorStudentSilentAssessmentStatsData,
  QueryAdvisorStudentSilentAssessmentStatsResponses,
  QueryAdvisorStudentSilentAssessmentStatsErrors,
  QueryAdvisorStudentTakeoutAssessmentStatsData,
  QueryAdvisorStudentTakeoutAssessmentStatsResponses,
  QueryAdvisorStudentTakeoutAssessmentStatsErrors,
  QueryAdvisorStudentLiftAssessmentStatsData,
  QueryAdvisorStudentLiftAssessmentStatsResponses,
  QueryAdvisorStudentLiftAssessmentStatsErrors,
  ListAdvisorStudentDisciplinesData,
  ListAdvisorStudentDisciplinesResponses,
  ListAdvisorStudentDisciplinesErrors,
  ListAdvisorStudentLiftAssessmentsData,
  ListAdvisorStudentLiftAssessmentsResponses,
  ListAdvisorStudentLiftAssessmentsErrors,
  ListAdvisorStudentTakeoutAssessmentsData,
  ListAdvisorStudentTakeoutAssessmentsResponses,
  ListAdvisorStudentTakeoutAssessmentsErrors,
  QueryAdvisorStudentTabletViolationStatsData,
  QueryAdvisorStudentTabletViolationStatsResponses,
  QueryAdvisorStudentTabletViolationStatsErrors,
  ListAdvisorTeacherAssessmentItemStatsData,
  ListAdvisorTeacherAssessmentItemStatsResponses,
  ListAdvisorTeacherAssessmentItemStatsErrors,
  ListAdvisorStudentRecordsData,
  ListAdvisorStudentRecordsResponses,
  ListAdvisorStudentRecordsErrors,
  QueryAdvisorTeacherAttendanceStatsData,
  QueryAdvisorTeacherAttendanceStatsResponses,
  QueryAdvisorTeacherAttendanceStatsErrors,
  ListAdvisorV2TeacherAttendancesData,
  ListAdvisorV2TeacherAttendancesResponses,
  ListAdvisorV2TeacherAttendancesErrors,
  QueryAdvisorStudentCertificationStatsData,
  QueryAdvisorStudentCertificationStatsResponses,
  QueryAdvisorStudentCertificationStatsErrors,
  QueryAdvisorStudentAttendanceStatsData,
  QueryAdvisorStudentAttendanceStatsResponses,
  QueryAdvisorStudentAttendanceStatsErrors,
  QueryAdvisorStudentAbsenceStatsData,
  QueryAdvisorStudentAbsenceStatsResponses,
  QueryAdvisorStudentAbsenceStatsErrors,
  QueryAdvisorDailyStudentAttendanceStatsData,
  QueryAdvisorDailyStudentAttendanceStatsResponses,
  QueryAdvisorDailyStudentAttendanceStatsErrors,
  ListAdvisorStudentSilentSchoolsData,
  ListAdvisorStudentSilentSchoolsResponses,
  ListAdvisorStudentSilentSchoolsErrors,
  QueryAdvisorStudentMoralAssessmentStatsData,
  QueryAdvisorStudentMoralAssessmentStatsResponses,
  QueryAdvisorStudentMoralAssessmentStatsErrors,
  ListAdvisorStudentMoralAssessmentsData,
  ListAdvisorStudentMoralAssessmentsResponses,
  ListAdvisorStudentMoralAssessmentsErrors,
  ListAdvisorStudentCertificationsV2Data,
  ListAdvisorStudentCertificationsV2Responses,
  ListAdvisorStudentCertificationsV2Errors,
  ListAdvisorStudentAttendancesV2Data,
  ListAdvisorStudentAttendancesV2Responses,
  ListAdvisorStudentAttendancesV2Errors,
  ListAdvisorStudentAbsencesV2Data,
  ListAdvisorStudentAbsencesV2Responses,
  ListAdvisorStudentAbsencesV2Errors,
  ListAdvisorStudentAbnormalAttendancesData,
  ListAdvisorStudentAbnormalAttendancesResponses,
  ListAdvisorStudentAbnormalAttendancesErrors,
  ListAdvisorDailyStudentAttendancesData,
  ListAdvisorDailyStudentAttendancesResponses,
  ListAdvisorDailyStudentAttendancesErrors,
  QuerySemesterDataData,
  QuerySemesterDataResponses,
  QuerySemesterDataErrors,
  ListAdvisorStudentCreditsData,
  ListAdvisorStudentCreditsResponses,
  ListAdvisorStudentCreditsErrors,
  QueryAdvisorStudentGpaStatsData,
  QueryAdvisorStudentGpaStatsResponses,
  QueryAdvisorStudentGpaStatsErrors,
  ListAdvisorStudentClassAssessmentItemAnaData,
  ListAdvisorStudentClassAssessmentItemAnaResponses,
  ListAdvisorStudentClassAssessmentItemAnaErrors,
  ListAdvisorStudentExamPerformanceAnalysisData,
  ListAdvisorStudentExamPerformanceAnalysisResponses,
  ListAdvisorStudentExamPerformanceAnalysisErrors,
  ListAdvisorStudentEffortOutcomeMatrixData,
  ListAdvisorStudentEffortOutcomeMatrixResponses,
  ListAdvisorStudentEffortOutcomeMatrixErrors,
  ListAdvisorStudentHolisticProfileData,
  ListAdvisorStudentHolisticProfileResponses,
  ListAdvisorStudentHolisticProfileErrors,
  ListAdvisorStudentClassAssessmentAvgGradeAnaData,
  ListAdvisorStudentClassAssessmentAvgGradeAnaResponses,
  ListAdvisorStudentClassAssessmentAvgGradeAnaErrors,
  ListAdvisorStudentClassAssessmentGradeAnaData,
  ListAdvisorStudentClassAssessmentGradeAnaResponses,
  ListAdvisorStudentClassAssessmentGradeAnaErrors,
  ListAdvisorStudentUnpassSubjectData,
  ListAdvisorStudentUnpassSubjectResponses,
  ListAdvisorStudentUnpassSubjectErrors,
  ListAdvisorStudentGpasData,
  ListAdvisorStudentGpasResponses,
  ListAdvisorStudentGpasErrors,
  ListAdvisorStudentSemesterGpasData,
  ListAdvisorStudentSemesterGpasResponses,
  ListAdvisorStudentSemesterGpasErrors,
  ListAdvisorStudentExamGradesV2Data,
  ListAdvisorStudentExamGradesV2Responses,
  ListAdvisorStudentExamGradesV2Errors,
  ListAdvisorStudentExamsData,
  ListAdvisorStudentExamsResponses,
  ListAdvisorStudentExamsErrors,
  QueryAdvisorStudentExamStatsV2Data,
  QueryAdvisorStudentExamStatsV2Responses,
  QueryAdvisorStudentExamStatsV2Errors,
  QueryAdvisorStudentExamRankStatsV2Data,
  QueryAdvisorStudentExamRankStatsV2Responses,
  QueryAdvisorStudentExamRankStatsV2Errors,
  ListAdvisorStudentExamNamesData,
  ListAdvisorStudentExamNamesResponses,
  ListAdvisorStudentExamNamesErrors,
  ListAdvisorStudentExamGradeStatsV2Data,
  ListAdvisorStudentExamGradeStatsV2Responses,
  ListAdvisorStudentExamGradeStatsV2Errors,
  ListExamTagsData,
  ListExamTagsResponses,
  ListExamTagsErrors,
  ListAdvisorStudentClassAssessmentVariancesData,
  ListAdvisorStudentClassAssessmentVariancesResponses,
  ListAdvisorStudentClassAssessmentVariancesErrors,
  QueryAdvisorStudentExamStatsData,
  QueryAdvisorStudentExamStatsResponses,
  QueryAdvisorStudentExamStatsErrors,
  QueryAdvisorStudentExamRankStatsData,
  QueryAdvisorStudentExamRankStatsResponses,
  QueryAdvisorStudentExamRankStatsErrors,
  QueryAdvisorStudentClassTaskSubmittedStatsData,
  QueryAdvisorStudentClassTaskSubmittedStatsResponses,
  QueryAdvisorStudentClassTaskSubmittedStatsErrors,
  QueryAdvisorStudentClassTaskOverdueStatsData,
  QueryAdvisorStudentClassTaskOverdueStatsResponses,
  QueryAdvisorStudentClassTaskOverdueStatsErrors,
  ListAdvisorStudentExamGradesData,
  ListAdvisorStudentExamGradesResponses,
  ListAdvisorStudentExamGradesErrors,
  ListAdvisorStudentExamGradeStatsData,
  ListAdvisorStudentExamGradeStatsResponses,
  ListAdvisorStudentExamGradeStatsErrors,
  ListAdvisorStudentClassTasksData,
  ListAdvisorStudentClassTasksResponses,
  ListAdvisorStudentClassTasksErrors,
  ListAdvisorStudentClassTaskPoorPerformancesData,
  ListAdvisorStudentClassTaskPoorPerformancesResponses,
  ListAdvisorStudentClassTaskPoorPerformancesErrors,
  ListAdvisorStudentDirectionsData,
  ListAdvisorStudentDirectionsResponses,
  ListAdvisorStudentDirectionsErrors,
  QueryAdvisorStudentDirectionStatsData,
  QueryAdvisorStudentDirectionStatsResponses,
  QueryAdvisorStudentDirectionStatsErrors,
  ListAdvisorStudentCertificationsData,
  ListAdvisorStudentCertificationsResponses,
  ListAdvisorStudentCertificationsErrors,
  ListAdvisorStudentAbsencesData,
  ListAdvisorStudentAbsencesResponses,
  ListAdvisorStudentAbsencesErrors,
  ListAdvisorStudentAttendancesData,
  ListAdvisorStudentAttendancesResponses,
  ListAdvisorStudentAttendancesErrors,
  GetExamSubjectScoresByStudentUsinData,
  GetExamSubjectScoresByStudentUsinResponses,
  GetExamSubjectScoresByStudentUsinErrors,
  GetExamGradesByStudentUsinData,
  GetExamGradesByStudentUsinResponses,
  GetExamGradesByStudentUsinErrors,
  QuerySemestersData,
  QuerySemestersResponses,
  QuerySemestersErrors,
} from './types.gen'

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean
> = ClientOptions<TData, ThrowOnError> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>
}

/**
 * 771954818029931 ListAdvisorStudentTabletViolations 导师学生平板使用情况-按学生维度+本周、上周、本月、本学期统计任意维度超过10次统计明细
 */
export const listAdvisorStudentTabletViolations = <
  ThrowOnError extends boolean = false
>(
  options: Options<ListAdvisorStudentTabletViolationsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ListAdvisorStudentTabletViolationsResponses,
    ListAdvisorStudentTabletViolationsErrors,
    ThrowOnError
  >({
    url: '/advisor/list_advisor_student_tablet_violations',
    ...options,
  })
}

/**
 * 770398032648366 ListAdvisorStudentTabletViolationUrls ListAdvisorStudentTabletViolationUrls
 */
export const listAdvisorStudentTabletViolationUrls = <
  ThrowOnError extends boolean = false
>(
  options: Options<ListAdvisorStudentTabletViolationUrlsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ListAdvisorStudentTabletViolationUrlsResponses,
    ListAdvisorStudentTabletViolationUrlsErrors,
    ThrowOnError
  >({
    url: '/advisor/list_advisor_student_tablet_violation_urls',
    ...options,
  })
}

/**
 * 770398032648365 ListAdvisorStudentTabletViolationOfflines ListAdvisorStudentTabletViolationOfflines
 */
export const listAdvisorStudentTabletViolationOfflines = <
  ThrowOnError extends boolean = false
>(
  options: Options<ListAdvisorStudentTabletViolationOfflinesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ListAdvisorStudentTabletViolationOfflinesResponses,
    ListAdvisorStudentTabletViolationOfflinesErrors,
    ThrowOnError
  >({
    url: '/advisor/list_advisor_student_tablet_violation_offlines',
    ...options,
  })
}

/**
 * 770398032648364 ListAdvisorStudentTabletViolationDeviceUses ListAdvisorStudentTabletViolationDeviceUses
 */
export const listAdvisorStudentTabletViolationDeviceUses = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    ListAdvisorStudentTabletViolationDeviceUsesData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    ListAdvisorStudentTabletViolationDeviceUsesResponses,
    ListAdvisorStudentTabletViolationDeviceUsesErrors,
    ThrowOnError
  >({
    url: '/advisor/list_advisor_student_tablet_violation_device_uses',
    ...options,
  })
}

/**
 * 770398032648363 ListAdvisorStudentTabletViolationAppUses ListAdvisorStudentTabletViolationAppUses
 */
export const listAdvisorStudentTabletViolationAppUses = <
  ThrowOnError extends boolean = false
>(
  options: Options<ListAdvisorStudentTabletViolationAppUsesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ListAdvisorStudentTabletViolationAppUsesResponses,
    ListAdvisorStudentTabletViolationAppUsesErrors,
    ThrowOnError
  >({
    url: '/advisor/list_advisor_student_tablet_violation_app_uses',
    ...options,
  })
}

/**
 * 770398032648362 ListAdvisorStudentTabletUrlVisits ListAdvisorStudentTabletUrlVisits
 */
export const listAdvisorStudentTabletUrlVisits = <
  ThrowOnError extends boolean = false
>(
  options: Options<ListAdvisorStudentTabletUrlVisitsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ListAdvisorStudentTabletUrlVisitsResponses,
    ListAdvisorStudentTabletUrlVisitsErrors,
    ThrowOnError
  >({
    url: '/advisor/list_advisor_student_tablet_url_visits',
    ...options,
  })
}

/**
 * 770398032648357 ListAdvisorStudentTabletDeviceUses 导师学生平板使用情况-设备使用时长统计明细
 */
export const listAdvisorStudentTabletDeviceUses = <
  ThrowOnError extends boolean = false
>(
  options: Options<ListAdvisorStudentTabletDeviceUsesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ListAdvisorStudentTabletDeviceUsesResponses,
    ListAdvisorStudentTabletDeviceUsesErrors,
    ThrowOnError
  >({
    url: '/advisor/list_advisor_student_tablet_device_uses',
    ...options,
  })
}

/**
 * 770398032648361 ListAdvisorStudentTabletAppUses ListAdvisorStudentTabletAppUses
 */
export const listAdvisorStudentTabletAppUses = <
  ThrowOnError extends boolean = false
>(
  options: Options<ListAdvisorStudentTabletAppUsesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ListAdvisorStudentTabletAppUsesResponses,
    ListAdvisorStudentTabletAppUsesErrors,
    ThrowOnError
  >({
    url: '/advisor/list_advisor_student_tablet_app_uses',
    ...options,
  })
}

/**
 * 773968821926463 QueryAdvisorStudentSilentAssessmentStats 静校管理
 */
export const queryAdvisorStudentSilentAssessmentStats = <
  ThrowOnError extends boolean = false
>(
  options: Options<QueryAdvisorStudentSilentAssessmentStatsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    QueryAdvisorStudentSilentAssessmentStatsResponses,
    QueryAdvisorStudentSilentAssessmentStatsErrors,
    ThrowOnError
  >({
    url: '/advisor/query_advisor_student_silent_assessment_stats',
    ...options,
  })
}

/**
 * 773968821926324 QueryAdvisorStudentTakeoutAssessmentStats 学生乘梯权限违规统计
 */
export const queryAdvisorStudentTakeoutAssessmentStats = <
  ThrowOnError extends boolean = false
>(
  options: Options<QueryAdvisorStudentTakeoutAssessmentStatsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    QueryAdvisorStudentTakeoutAssessmentStatsResponses,
    QueryAdvisorStudentTakeoutAssessmentStatsErrors,
    ThrowOnError
  >({
    url: '/advisor/query_advisor_student_takeout_assessment_stats',
    ...options,
  })
}

/**
 * 773968821926325 QueryAdvisorStudentLiftAssessmentStats 学生乘梯权限统计
 */
export const queryAdvisorStudentLiftAssessmentStats = <
  ThrowOnError extends boolean = false
>(
  options: Options<QueryAdvisorStudentLiftAssessmentStatsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    QueryAdvisorStudentLiftAssessmentStatsResponses,
    QueryAdvisorStudentLiftAssessmentStatsErrors,
    ThrowOnError
  >({
    url: '/advisor/query_advisor_student_lift_assessment_stats',
    ...options,
  })
}

/**
 * 414758875252085 ListAdvisorStudentDisciplines 导师的学生异常考勤、请假、电子设备违规、处分的汇总列表
 */
export const listAdvisorStudentDisciplines = <
  ThrowOnError extends boolean = false
>(
  options: Options<ListAdvisorStudentDisciplinesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ListAdvisorStudentDisciplinesResponses,
    ListAdvisorStudentDisciplinesErrors,
    ThrowOnError
  >({
    url: '/advisor/list_student_disciplines',
    ...options,
  })
}

/**
 * 773968821926323 ListAdvisorStudentLiftAssessments 学生乘梯权限违规
 */
export const listAdvisorStudentLiftAssessments = <
  ThrowOnError extends boolean = false
>(
  options: Options<ListAdvisorStudentLiftAssessmentsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ListAdvisorStudentLiftAssessmentsResponses,
    ListAdvisorStudentLiftAssessmentsErrors,
    ThrowOnError
  >({
    url: '/advisor/list_advisor_student_lift_assessments',
    ...options,
  })
}

/**
 * 773968821926321 ListAdvisorStudentTakeoutAssessments 学生外卖违规
 */
export const listAdvisorStudentTakeoutAssessments = <
  ThrowOnError extends boolean = false
>(
  options: Options<ListAdvisorStudentTakeoutAssessmentsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ListAdvisorStudentTakeoutAssessmentsResponses,
    ListAdvisorStudentTakeoutAssessmentsErrors,
    ThrowOnError
  >({
    url: '/advisor/list_advisor_student_takeout_assessments',
    ...options,
  })
}

/**
 * 771954818029929 QueryAdvisorStudentTabletViolationStats 导师管理学生平板违规使用情况统计（按学生维度+本周、上周、本月、本学期统计任意维度超过10次）
 */
export const queryAdvisorStudentTabletViolationStats = <
  ThrowOnError extends boolean = false
>(
  options: Options<QueryAdvisorStudentTabletViolationStatsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    QueryAdvisorStudentTabletViolationStatsResponses,
    QueryAdvisorStudentTabletViolationStatsErrors,
    ThrowOnError
  >({
    url: '/advisor/query_advisor_student_tablet_violation_stats',
    ...options,
  })
}

/**
 * 414758875254685 ListAdvisorTeacherAssessmentItemStats 查询指定时间内，某学院教师的课程班评价项发布情况
 */
export const listAdvisorTeacherAssessmentItemStats = <
  ThrowOnError extends boolean = false
>(
  options: Options<ListAdvisorTeacherAssessmentItemStatsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ListAdvisorTeacherAssessmentItemStatsResponses,
    ListAdvisorTeacherAssessmentItemStatsErrors,
    ThrowOnError
  >({
    url: '/advisor/list_advisor_teacher_assessment_item_stats',
    ...options,
  })
}

/**
 * 414758875254164 ListAdvisorStudentRecords 导师的学生
 */
export const listAdvisorStudentRecords = <ThrowOnError extends boolean = false>(
  options: Options<ListAdvisorStudentRecordsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ListAdvisorStudentRecordsResponses,
    ListAdvisorStudentRecordsErrors,
    ThrowOnError
  >({
    url: '/advisor/list_advisor_student_records',
    ...options,
  })
}

/**
 * 414758875252781 QueryAdvisorTeacherAttendanceStats 首页查询教师考勤统计
 */
export const queryAdvisorTeacherAttendanceStats = <
  ThrowOnError extends boolean = false
>(
  options: Options<QueryAdvisorTeacherAttendanceStatsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    QueryAdvisorTeacherAttendanceStatsResponses,
    QueryAdvisorTeacherAttendanceStatsErrors,
    ThrowOnError
  >({
    url: '/advisor/query_advisor_teacher_attendance_stats',
    ...options,
  })
}

/**
 * 414758875252783 ListAdvisorV2TeacherAttendances 查看教师考勤明细v2
 */
export const listAdvisorV2TeacherAttendances = <
  ThrowOnError extends boolean = false
>(
  options: Options<ListAdvisorV2TeacherAttendancesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ListAdvisorV2TeacherAttendancesResponses,
    ListAdvisorV2TeacherAttendancesErrors,
    ThrowOnError
  >({
    url: '/advisor/list_advisor_teacher_attendances_v2',
    ...options,
  })
}

/**
 * 414758875252070 QueryAdvisorStudentCertificationStats 首页处分统计
 */
export const queryAdvisorStudentCertificationStats = <
  ThrowOnError extends boolean = false
>(
  options: Options<QueryAdvisorStudentCertificationStatsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    QueryAdvisorStudentCertificationStatsResponses,
    QueryAdvisorStudentCertificationStatsErrors,
    ThrowOnError
  >({
    url: '/advisor/query_student_certification_stats',
    ...options,
  })
}

/**
 * 414758875252113 QueryAdvisorStudentAttendanceStats 首页学生异常考勤统计
 */
export const queryAdvisorStudentAttendanceStats = <
  ThrowOnError extends boolean = false
>(
  options: Options<QueryAdvisorStudentAttendanceStatsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    QueryAdvisorStudentAttendanceStatsResponses,
    QueryAdvisorStudentAttendanceStatsErrors,
    ThrowOnError
  >({
    url: '/advisor/query_student_attendance_stats',
    ...options,
  })
}

/**
 * 414758875252066 QueryAdvisorStudentAbsenceStats 首页请假统计
 */
export const queryAdvisorStudentAbsenceStats = <
  ThrowOnError extends boolean = false
>(
  options: Options<QueryAdvisorStudentAbsenceStatsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    QueryAdvisorStudentAbsenceStatsResponses,
    QueryAdvisorStudentAbsenceStatsErrors,
    ThrowOnError
  >({
    url: '/advisor/query_student_absence_stats',
    ...options,
  })
}

/**
 * 414758875254482 QueryAdvisorDailyStudentAttendanceStats 导师学生今日异常考勤
 */
export const queryAdvisorDailyStudentAttendanceStats = <
  ThrowOnError extends boolean = false
>(
  options: Options<QueryAdvisorDailyStudentAttendanceStatsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    QueryAdvisorDailyStudentAttendanceStatsResponses,
    QueryAdvisorDailyStudentAttendanceStatsErrors,
    ThrowOnError
  >({
    url: '/advisor/query_advisor_daily_student_attendance_stats',
    ...options,
  })
}

/**
 * 414758875255453 ListAdvisorStudentSilentSchools ListAdvisorStudentSilentSchools
 */
export const listAdvisorStudentSilentSchools = <
  ThrowOnError extends boolean = false
>(
  options: Options<ListAdvisorStudentSilentSchoolsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ListAdvisorStudentSilentSchoolsResponses,
    ListAdvisorStudentSilentSchoolsErrors,
    ThrowOnError
  >({
    url: '/advisor/list_advisor_student_silent_schools',
    ...options,
  })
}

/**
 * 414758875252073 QueryAdvisorStudentMoralAssessmentStats 首页电子设备违规统计
 */
export const queryAdvisorStudentMoralAssessmentStats = <
  ThrowOnError extends boolean = false
>(
  options: Options<QueryAdvisorStudentMoralAssessmentStatsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    QueryAdvisorStudentMoralAssessmentStatsResponses,
    QueryAdvisorStudentMoralAssessmentStatsErrors,
    ThrowOnError
  >({
    url: '/advisor/query_student_moral_assessment_stats',
    ...options,
  })
}

/**
 * 414758875252083 ListAdvisorStudentMoralAssessments 导师的学生电子设备违规列表
 */
export const listAdvisorStudentMoralAssessments = <
  ThrowOnError extends boolean = false
>(
  options: Options<ListAdvisorStudentMoralAssessmentsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ListAdvisorStudentMoralAssessmentsResponses,
    ListAdvisorStudentMoralAssessmentsErrors,
    ThrowOnError
  >({
    url: '/advisor/list_student_moral_assessments',
    ...options,
  })
}

/**
 * 414758875255452 ListAdvisorStudentCertificationsV2 处分列表
 */
export const listAdvisorStudentCertificationsV2 = <
  ThrowOnError extends boolean = false
>(
  options: Options<ListAdvisorStudentCertificationsV2Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ListAdvisorStudentCertificationsV2Responses,
    ListAdvisorStudentCertificationsV2Errors,
    ThrowOnError
  >({
    url: '/advisor/list_advisor_student_certifications_v2',
    ...options,
  })
}

/**
 * 414758875254166 ListAdvisorStudentAttendancesV2 导师学生考勤列表
 */
export const listAdvisorStudentAttendancesV2 = <
  ThrowOnError extends boolean = false
>(
  options: Options<ListAdvisorStudentAttendancesV2Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ListAdvisorStudentAttendancesV2Responses,
    ListAdvisorStudentAttendancesV2Errors,
    ThrowOnError
  >({
    url: '/advisor/list_advisor_student_attendances_v2',
    ...options,
  })
}

/**
 * 414758875254827 ListAdvisorStudentAbsencesV2 查看学生请假
 */
export const listAdvisorStudentAbsencesV2 = <
  ThrowOnError extends boolean = false
>(
  options: Options<ListAdvisorStudentAbsencesV2Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ListAdvisorStudentAbsencesV2Responses,
    ListAdvisorStudentAbsencesV2Errors,
    ThrowOnError
  >({
    url: '/advisor/list_advisor_student_absences_v2',
    ...options,
  })
}

/**
 * 414758875255451 ListAdvisorStudentAbnormalAttendances 行知考勤列表
 */
export const listAdvisorStudentAbnormalAttendances = <
  ThrowOnError extends boolean = false
>(
  options: Options<ListAdvisorStudentAbnormalAttendancesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ListAdvisorStudentAbnormalAttendancesResponses,
    ListAdvisorStudentAbnormalAttendancesErrors,
    ThrowOnError
  >({
    url: '/advisor/list_advisor_student_abnormal_attendances',
    ...options,
  })
}

/**
 * 414758875254483 ListAdvisorDailyStudentAttendances 导师今日异常考勤明细
 */
export const listAdvisorDailyStudentAttendances = <
  ThrowOnError extends boolean = false
>(
  options: Options<ListAdvisorDailyStudentAttendancesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ListAdvisorDailyStudentAttendancesResponses,
    ListAdvisorDailyStudentAttendancesErrors,
    ThrowOnError
  >({
    url: '/advisor/list_advisor_daily_student_attendances',
    ...options,
  })
}

/**
 * 414758875252075 QuerySemesterData 查询当天对应的学期信息、当前用户是否是导师、用于首页调用其它接口使用
 */
export const querySemesterData = <ThrowOnError extends boolean = false>(
  options: Options<QuerySemesterDataData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    QuerySemesterDataResponses,
    QuerySemesterDataErrors,
    ThrowOnError
  >({
    url: '/query_semester_data',
    ...options,
  })
}

/**
 * 414758875253578 ListAdvisorStudentCredits 导师-评价项与gpa-学生gpa学分列表
 */
export const listAdvisorStudentCredits = <ThrowOnError extends boolean = false>(
  options: Options<ListAdvisorStudentCreditsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ListAdvisorStudentCreditsResponses,
    ListAdvisorStudentCreditsErrors,
    ThrowOnError
  >({
    url: '/advisor/list_advisor_student_credits',
    ...options,
  })
}

/**
 * 414758875253577 QueryAdvisorStudentGpaStats 导师-评价项与gpa-各档位gpa分布情况（各档位区间有哪些学生）
 */
export const queryAdvisorStudentGpaStats = <
  ThrowOnError extends boolean = false
>(
  options: Options<QueryAdvisorStudentGpaStatsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    QueryAdvisorStudentGpaStatsResponses,
    QueryAdvisorStudentGpaStatsErrors,
    ThrowOnError
  >({
    url: '/advisor/query_advisor_student_gpa_stats',
    ...options,
  })
}

/**
 * 414758875257522 ListAdvisorStudentClassAssessmentItemAna 导师导生过程性评价分析：课程班评价项上的平均表现
 */
export const listAdvisorStudentClassAssessmentItemAna = <
  ThrowOnError extends boolean = false
>(
  options: Options<ListAdvisorStudentClassAssessmentItemAnaData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ListAdvisorStudentClassAssessmentItemAnaResponses,
    ListAdvisorStudentClassAssessmentItemAnaErrors,
    ThrowOnError
  >({
    url: '/advisor/list_advisor_student_class_assessment_item_analysis',
    ...options,
  })
}

/**
 * 414758875257666 ListAdvisorStudentExamPerformanceAnalysis 导师导师考试成绩分析：关于某次重要考试（如期中/期末考）的综合分析报告，包括群体平均表现、科目强弱项和重点关注学生名单
 */
export const listAdvisorStudentExamPerformanceAnalysis = <
  ThrowOnError extends boolean = false
>(
  options: Options<ListAdvisorStudentExamPerformanceAnalysisData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ListAdvisorStudentExamPerformanceAnalysisResponses,
    ListAdvisorStudentExamPerformanceAnalysisErrors,
    ThrowOnError
  >({
    url: '/advisor/list_advisor_student_exam_performance_analysis',
    ...options,
  })
}

/**
 * 414758875257663 ListAdvisorStudentEffortOutcomeMatrix 导师导师考试成绩与过程性评价综合分析：将学生群体在每一门学科上的表现划分到四个象限：“高努力-高成果”（学霸）、“高努力-低成果”（勤奋但方法待提升）、“低努力-高成果”（聪明但需激励）、“低努力-低成果”（全面告急），为导师提供极其精准的干预方向
 */
export const listAdvisorStudentEffortOutcomeMatrix = <
  ThrowOnError extends boolean = false
>(
  options: Options<ListAdvisorStudentEffortOutcomeMatrixData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ListAdvisorStudentEffortOutcomeMatrixResponses,
    ListAdvisorStudentEffortOutcomeMatrixErrors,
    ThrowOnError
  >({
    url: '/advisor/list_advisor_student_effort_outcome_matrix',
    ...options,
  })
}

/**
 * 414758875257656 ListAdvisorStudentHolisticProfile 导师导师考试成绩、过程性评价、学分综合分析：为导师名下每一位学生，根据其拥有的任意两个或三个维度的数据（过程、表现、成就），生成一份深度、全面的个人诊断报告和发展画像。确保只要学生至少有两个维度的数据，就能得到有意义的分析
 */
export const listAdvisorStudentHolisticProfile = <
  ThrowOnError extends boolean = false
>(
  options: Options<ListAdvisorStudentHolisticProfileData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ListAdvisorStudentHolisticProfileResponses,
    ListAdvisorStudentHolisticProfileErrors,
    ThrowOnError
  >({
    url: '/advisor/list_advisor_student_holistic_profile',
    ...options,
  })
}

/**
 * 414758875257506 ListAdvisorStudentClassAssessmentAvgGradeAna 导师导生过程性评价分析：平均课程班评价项总分得分率
 */
export const listAdvisorStudentClassAssessmentAvgGradeAna = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    ListAdvisorStudentClassAssessmentAvgGradeAnaData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    ListAdvisorStudentClassAssessmentAvgGradeAnaResponses,
    ListAdvisorStudentClassAssessmentAvgGradeAnaErrors,
    ThrowOnError
  >({
    url: '/advisor/list_advisor_student_class_assessment_avg_grade_analysis',
    ...options,
  })
}

/**
 * 414758875257516 ListAdvisorStudentClassAssessmentGradeAna 导师导生过程性评价分析：每个学生过程性评价的综合统计指标
 */
export const listAdvisorStudentClassAssessmentGradeAna = <
  ThrowOnError extends boolean = false
>(
  options: Options<ListAdvisorStudentClassAssessmentGradeAnaData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ListAdvisorStudentClassAssessmentGradeAnaResponses,
    ListAdvisorStudentClassAssessmentGradeAnaErrors,
    ThrowOnError
  >({
    url: '/advisor/list_advisor_student_class_assessment_grade_analysis',
    ...options,
  })
}

/**
 * 414758875257013 ListAdvisorStudentUnpassSubject 教务查看无军训学分学生名单
 */
export const listAdvisorStudentUnpassSubject = <
  ThrowOnError extends boolean = false
>(
  options: Options<ListAdvisorStudentUnpassSubjectData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ListAdvisorStudentUnpassSubjectResponses,
    ListAdvisorStudentUnpassSubjectErrors,
    ThrowOnError
  >({
    url: '/advisor/list_advisor_student_unpass_subject',
    ...options,
  })
}

/**
 * 414758875252816 ListAdvisorStudentGpas ListAdvisorStudentGpas
 */
export const listAdvisorStudentGpas = <ThrowOnError extends boolean = false>(
  options: Options<ListAdvisorStudentGpasData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ListAdvisorStudentGpasResponses,
    ListAdvisorStudentGpasErrors,
    ThrowOnError
  >({
    url: '/advisor/list_advisor_student_gpas',
    ...options,
  })
}

/**
 * 414758875252959 ListAdvisorStudentSemesterGpas ListAdvisorStudentSemesterGpas
 */
export const listAdvisorStudentSemesterGpas = <
  ThrowOnError extends boolean = false
>(
  options: Options<ListAdvisorStudentSemesterGpasData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ListAdvisorStudentSemesterGpasResponses,
    ListAdvisorStudentSemesterGpasErrors,
    ThrowOnError
  >({
    url: '/advisor/list_advisor_student_semester_gpas',
    ...options,
  })
}

/**
 * 414758875256042 ListAdvisorStudentExamGradesV2 导师学生考试总分与科目得分列表
 */
export const listAdvisorStudentExamGradesV2 = <
  ThrowOnError extends boolean = false
>(
  options: Options<ListAdvisorStudentExamGradesV2Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ListAdvisorStudentExamGradesV2Responses,
    ListAdvisorStudentExamGradesV2Errors,
    ThrowOnError
  >({
    url: '/advisor/list_advisor_student_exam_grades_v2',
    ...options,
  })
}

/**
 * 414758875256008 ListAdvisorStudentExams 导师查看学生历次考试
 */
export const listAdvisorStudentExams = <ThrowOnError extends boolean = false>(
  options: Options<ListAdvisorStudentExamsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ListAdvisorStudentExamsResponses,
    ListAdvisorStudentExamsErrors,
    ThrowOnError
  >({
    url: '/advisor/list_advisor_student_exams',
    ...options,
  })
}

/**
 * 414758875256054 QueryAdvisorStudentExamStatsV2 导师学生考试统计信息
 */
export const queryAdvisorStudentExamStatsV2 = <
  ThrowOnError extends boolean = false
>(
  options: Options<QueryAdvisorStudentExamStatsV2Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    QueryAdvisorStudentExamStatsV2Responses,
    QueryAdvisorStudentExamStatsV2Errors,
    ThrowOnError
  >({
    url: '/advisor/query_advisor_student_exam_stats_v2',
    ...options,
  })
}

/**
 * 414758875256053 QueryAdvisorStudentExamRankStatsV2 导师学生考试排名变化情况(对比指定考试)
 */
export const queryAdvisorStudentExamRankStatsV2 = <
  ThrowOnError extends boolean = false
>(
  options: Options<QueryAdvisorStudentExamRankStatsV2Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    QueryAdvisorStudentExamRankStatsV2Responses,
    QueryAdvisorStudentExamRankStatsV2Errors,
    ThrowOnError
  >({
    url: '/advisor/query_advisor_student_exam_rank_stats_v2',
    ...options,
  })
}

/**
 * 414758875256048 ListAdvisorStudentExamNames 导师学生考试名列表
 */
export const listAdvisorStudentExamNames = <
  ThrowOnError extends boolean = false
>(
  options: Options<ListAdvisorStudentExamNamesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ListAdvisorStudentExamNamesResponses,
    ListAdvisorStudentExamNamesErrors,
    ThrowOnError
  >({
    url: '/advisor/list_advisor_student_exam_names',
    ...options,
  })
}

/**
 * 414758875256041 ListAdvisorStudentExamGradeStatsV2 导师学生最新考试的成绩区间分布情况
 */
export const listAdvisorStudentExamGradeStatsV2 = <
  ThrowOnError extends boolean = false
>(
  options: Options<ListAdvisorStudentExamGradeStatsV2Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ListAdvisorStudentExamGradeStatsV2Responses,
    ListAdvisorStudentExamGradeStatsV2Errors,
    ThrowOnError
  >({
    url: '/advisor/list_advisor_student_exam_grade_stats_v2',
    ...options,
  })
}

/**
 * 414758875256018 ListExamTags 获取考试标签
 */
export const listExamTags = <ThrowOnError extends boolean = false>(
  options: Options<ListExamTagsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ListExamTagsResponses,
    ListExamTagsErrors,
    ThrowOnError
  >({
    url: '/list_exam_tags',
    ...options,
  })
}

/**
 * 414758875253585 ListAdvisorStudentClassAssessmentVariances 导师-评价项与gpa-课程班评价项方差分布情况（以学生为单位）
 */
export const listAdvisorStudentClassAssessmentVariances = <
  ThrowOnError extends boolean = false
>(
  options: Options<ListAdvisorStudentClassAssessmentVariancesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ListAdvisorStudentClassAssessmentVariancesResponses,
    ListAdvisorStudentClassAssessmentVariancesErrors,
    ThrowOnError
  >({
    url: '/advisor/list_advisor_student_class_assessment_variances',
    ...options,
  })
}

/**
 * 414758875253580 QueryAdvisorStudentExamStats 导师-考试-最新考试统计信息
 */
export const queryAdvisorStudentExamStats = <
  ThrowOnError extends boolean = false
>(
  options: Options<QueryAdvisorStudentExamStatsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    QueryAdvisorStudentExamStatsResponses,
    QueryAdvisorStudentExamStatsErrors,
    ThrowOnError
  >({
    url: '/advisor/query_advisor_student_exam_stats',
    ...options,
  })
}

/**
 * 414758875253584 QueryAdvisorStudentExamRankStats 导师-考试-排名上升10及以上、排名下降10及以下学生列表
 */
export const queryAdvisorStudentExamRankStats = <
  ThrowOnError extends boolean = false
>(
  options: Options<QueryAdvisorStudentExamRankStatsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    QueryAdvisorStudentExamRankStatsResponses,
    QueryAdvisorStudentExamRankStatsErrors,
    ThrowOnError
  >({
    url: '/advisor/query_advisor_student_exam_rank_stats',
    ...options,
  })
}

/**
 * 414758875253571 QueryAdvisorStudentClassTaskSubmittedStats 导师-课程任务(作业完成情况)-各档位作业完成分布情况（各档位区间有哪些学生）- 完成情况
 */
export const queryAdvisorStudentClassTaskSubmittedStats = <
  ThrowOnError extends boolean = false
>(
  options: Options<QueryAdvisorStudentClassTaskSubmittedStatsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    QueryAdvisorStudentClassTaskSubmittedStatsResponses,
    QueryAdvisorStudentClassTaskSubmittedStatsErrors,
    ThrowOnError
  >({
    url: '/advisor/query_advisor_student_class_task_submitted_stats',
    ...options,
  })
}

/**
 * 414758875253572 QueryAdvisorStudentClassTaskOverdueStats 导师-课程任务(作业完成情况)-各档位作业完成分布情况（各档位区间有哪些学生）- 逾期情况
 */
export const queryAdvisorStudentClassTaskOverdueStats = <
  ThrowOnError extends boolean = false
>(
  options: Options<QueryAdvisorStudentClassTaskOverdueStatsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    QueryAdvisorStudentClassTaskOverdueStatsResponses,
    QueryAdvisorStudentClassTaskOverdueStatsErrors,
    ThrowOnError
  >({
    url: '/advisor/query_advisor_student_class_task_overdue_stats',
    ...options,
  })
}

/**
 * 414758875253583 ListAdvisorStudentExamGrades 导师-考试-学生最新考试总分列表
 */
export const listAdvisorStudentExamGrades = <
  ThrowOnError extends boolean = false
>(
  options: Options<ListAdvisorStudentExamGradesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ListAdvisorStudentExamGradesResponses,
    ListAdvisorStudentExamGradesErrors,
    ThrowOnError
  >({
    url: '/advisor/list_advisor_student_exam_grades',
    ...options,
  })
}

/**
 * 414758875253582 ListAdvisorStudentExamGradeStats 导师-考试-学生最新考试总分区间分布
 */
export const listAdvisorStudentExamGradeStats = <
  ThrowOnError extends boolean = false
>(
  options: Options<ListAdvisorStudentExamGradeStatsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ListAdvisorStudentExamGradeStatsResponses,
    ListAdvisorStudentExamGradeStatsErrors,
    ThrowOnError
  >({
    url: '/advisor/list_advisor_student_exam_grade_stats',
    ...options,
  })
}

/**
 * 414758875253574 ListAdvisorStudentClassTasks 导师-课程任务(作业完成情况) -学生作业完成明细
 */
export const listAdvisorStudentClassTasks = <
  ThrowOnError extends boolean = false
>(
  options: Options<ListAdvisorStudentClassTasksData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ListAdvisorStudentClassTasksResponses,
    ListAdvisorStudentClassTasksErrors,
    ThrowOnError
  >({
    url: '/advisor/list_advisor_student_class_tasks',
    ...options,
  })
}

/**
 * 414758875253573 ListAdvisorStudentClassTaskPoorPerformances 导师-课程任务(作业完成情况)-低档位学生名单
 */
export const listAdvisorStudentClassTaskPoorPerformances = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    ListAdvisorStudentClassTaskPoorPerformancesData,
    ThrowOnError
  >
) => {
  return (options.client ?? _heyApiClient).get<
    ListAdvisorStudentClassTaskPoorPerformancesResponses,
    ListAdvisorStudentClassTaskPoorPerformancesErrors,
    ThrowOnError
  >({
    url: '/advisor/list_advisor_student_class_task_poor_performances',
    ...options,
  })
}

/**
 * 414758875253569 ListAdvisorStudentDirections 导师-选课情况-各类选课组合分布统计（哪些组合有哪些学生）
 */
export const listAdvisorStudentDirections = <
  ThrowOnError extends boolean = false
>(
  options: Options<ListAdvisorStudentDirectionsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ListAdvisorStudentDirectionsResponses,
    ListAdvisorStudentDirectionsErrors,
    ThrowOnError
  >({
    url: '/advisor/list_advisor_student_directions',
    ...options,
  })
}

/**
 * 414758875253570 QueryAdvisorStudentDirectionStats 导师-选课情况-单科分布统计（各科有哪些学生）
 */
export const queryAdvisorStudentDirectionStats = <
  ThrowOnError extends boolean = false
>(
  options: Options<QueryAdvisorStudentDirectionStatsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    QueryAdvisorStudentDirectionStatsResponses,
    QueryAdvisorStudentDirectionStatsErrors,
    ThrowOnError
  >({
    url: '/advisor/query_advisor_student_direction_stats',
    ...options,
  })
}

/**
 * 414758875252084 ListAdvisorStudentCertifications 导师的学生的处分列表
 */
export const listAdvisorStudentCertifications = <
  ThrowOnError extends boolean = false
>(
  options: Options<ListAdvisorStudentCertificationsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ListAdvisorStudentCertificationsResponses,
    ListAdvisorStudentCertificationsErrors,
    ThrowOnError
  >({
    url: '/advisor/list_student_certifications',
    ...options,
  })
}

/**
 * 414758875252080 ListAdvisorStudentAbsences 导师的学生请假列表
 */
export const listAdvisorStudentAbsences = <
  ThrowOnError extends boolean = false
>(
  options: Options<ListAdvisorStudentAbsencesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ListAdvisorStudentAbsencesResponses,
    ListAdvisorStudentAbsencesErrors,
    ThrowOnError
  >({
    url: '/advisor/list_student_absences',
    ...options,
  })
}

/**
 * 414758875252082 ListAdvisorStudentAttendances 导师的学生的课程班异常考勤列表
 */
export const listAdvisorStudentAttendances = <
  ThrowOnError extends boolean = false
>(
  options: Options<ListAdvisorStudentAttendancesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ListAdvisorStudentAttendancesResponses,
    ListAdvisorStudentAttendancesErrors,
    ThrowOnError
  >({
    url: '/advisor/list_student_attendances',
    ...options,
  })
}

/**
 * 414758875253587 GetExamSubjectScoresByStudentUsin 通过学生学工号获取学生考试科目成绩
 */
export const getExamSubjectScoresByStudentUsin = <
  ThrowOnError extends boolean = false
>(
  options: Options<GetExamSubjectScoresByStudentUsinData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetExamSubjectScoresByStudentUsinResponses,
    GetExamSubjectScoresByStudentUsinErrors,
    ThrowOnError
  >({
    url: '/exam-subject-scores-by-student-usin',
    ...options,
  })
}

/**
 * 414758875253581 GetExamGradesByStudentUsin 按学生学工号获取历次考试总成绩数据
 */
export const getExamGradesByStudentUsin = <
  ThrowOnError extends boolean = false
>(
  options: Options<GetExamGradesByStudentUsinData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    GetExamGradesByStudentUsinResponses,
    GetExamGradesByStudentUsinErrors,
    ThrowOnError
  >({
    url: '/exam-grades-by-student-usin',
    ...options,
  })
}

/**
 * 414758875252286 QuerySemesters QuerySemesters
 */
export const querySemesters = <ThrowOnError extends boolean = false>(
  options: Options<QuerySemestersData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    QuerySemestersResponses,
    QuerySemestersErrors,
    ThrowOnError
  >({
    url: '/query_semesters',
    ...options,
  })
}
